import { render, staticRenderFns } from "./TripPagination.vue?vue&type=template&id=18f49434"
import script from "./TripPagination.vue?vue&type=script&lang=js"
export * from "./TripPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports